import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const keyboardSvg = (
    <svg width="120" height="120" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd"
              d="M52 29H14v24h38V29Zm-42-4v32h46V25H10Zm97 4H84v24h23V29Zm-27-4v32h31V25H80Zm4 44h23v24H84V69Zm-4 28V65h31v32H80ZM52 69H14v24h38V69Zm-42-4v32h46V65H10Zm60-19v-4h4v-4h-4v-4h-4v4h-4v4h4v4h4Zm0 41v-4h4v-4h-4v-4h-4v4h-4v4h4v4h4Zm30-40H90v-1.97L96.07 37H90v-3h10v2.17L94.07 44H100v3Z"
              fill="currentColor" />
    </svg>
)

const KeyboardShortcutIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {keyboardSvg}
    </SvgIcon>
)

export default KeyboardShortcutIcon